import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InfoTooltipComponent } from '../../components/info-tooltip/info-tooltip.component';

export interface WorkspacePageCard {
  title: string;
  description: string;
  meta?: string;
}

export interface WorkspacePageConfig {
  eyebrow?: string;
  title: string;
  description: string;
  cards: WorkspacePageCard[];
  highlights?: string[];
}

@Component({
  selector: 'app-workspace-page',
  standalone: true,
  imports: [InfoTooltipComponent],
  templateUrl: './workspace-page.component.html',
  styleUrls: ['./workspace-page.component.scss']
})
export class WorkspacePageComponent {
  private readonly route = inject(ActivatedRoute);

  readonly config = this.route.snapshot.data['workspacePage'] as WorkspacePageConfig;
}
